import { CodebookModel } from 'app/shared/model/shared.model';

export interface PublicAuthorityCodebook extends CodebookModel {
  oib: string;
  cityMunicipality: string;
  community: string;
  postalCode: string;
  postName: string;
  street: string;
  houseNumber: string;
  contactNumber: string;
  email: string;
  idJpt: string;
  relevantRegulation: string;
}

export interface CasePublicAuthorityModel {
  publicAuthority: PublicAuthorityCodebook[];
  issuedActs: IssuedActModel[];
}

export interface IssuedActModel {
  idIssuedAct: number;
  jptActivity: CodebookModel[];
  name: string;
  classificationMark: string;
  orderNumber: string;
  dateOfIssuing: Date;
  litigation: CodebookModel[];
}

export interface CasePublicAuthorityViewModel {
  idCasePublicAuthority: number;
  value: string;
  address: string;
  idJpt: string;
  jptAnswer: string;
  litigation: string;
  ordering: number;
  authorityDidAnswer: boolean;
}

export interface SpecialRegulationsComplianceModel {
  conferenceStart: Date;
  conferenceEnd: Date;
  conferenceDuration: string;
}

export const issuedActInitialData = {
  idIssuedAct: null,
  jptActivity: [],
  name: '',
  classificationMark: '',
  orderNumber: '',
  dateOfIssuing: null,
  litigation: [],
}

export const casePublicAuthorityInitialData = {
  publicAuthority: [],
  issuedActs: [],
}

export const specialRegulationsComplianceInitialData = {
  conferenceStart: null,
  conferenceEnd: null,
  conferenceDuration: '',
}
